<div class="block-pdf-container">
    <h-call-to-action
        i18n
        class="download-file-button"
        (click)="downloadFile()"
        [size]="'large'"
        [type]="'button'"
        [id]="'download-file'"
        [appearance]="'secondary'"
        [name]="'download-file'"
        [dataTestId]="'download-file'">
        {{ labelPdf }}
    </h-call-to-action>
</div>
